import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBugsnagComponent } from './simple-icons-bugsnag.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBugsnagComponent ],
    exports:      [ SimpleIconsBugsnagComponent ],
    bootstrap:    []
})
export class SimpleIconsBugsnagModule {}
